import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchUsersTx } from '../../actions'
import { disableCountryFilter } from '../../actions/country_filter'
import { resetCSVExport } from '../../actions/csv_export'
import { doTxSearch, resetTxSearch, termValidationErrorShow } from '../../actions/transaction_search'

export const searchBarOptions = [
  { name: 'client_guid', label: 'Access Code / GUID' },
  { name: 'drivers_license', label: 'National ID  / Drivers License' },
  { name: 'first_name', label: 'First Name' },
  { name: 'last_name', label: 'Last Name' },
  { name: 'full_name', label: 'Full Name' },
  { name: 'identity', label: 'Identity ID' },
  { name: 'phonenumber', label: 'Phone Number' },
  { name: 'txid', label: 'Transaction ID' },
]
const SearchBar = (props) => {
  const handleSelectFilter = (e) => {
    const { searchTerm } = props
    props.doTxSearch(searchTerm, e.target.value)
  }

  const handleChange = (e) => {
    const { searchParameter } = props
    props.doTxSearch(e.target.value, searchParameter)
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    const { searchParameter, searchTerm } = props
    props.updateSearchFilter({
      searchParameter,
      searchTerm,
    })
  }

  const handleSearchReset = (e) => {
    e.preventDefault()
    const { resetTxSearch, resetCSVExport } = props
    resetCSVExport()
    resetTxSearch()
  }

  const handleEnterKeyPress = (e) => {
    if (props.searchParameter && props.searchTerm) {
      if (e.key === 'Enter') {
        handleSearchSubmit(e)
      }
    }
  }

  const { searchError } = props
  let searchFormGroupClass = 'input-group'
  if (searchError) {
    searchFormGroupClass = 'input-group has-error'
  }
  return (
    <div className={searchFormGroupClass}>
      <input
        onKeyPress={(e) => handleEnterKeyPress(e)}
        name='search-field'
        className='form-control'
        placeholder='Search'
        value={props.searchTerm}
        onChange={(e) => handleChange(e)}
      />
      <select
        value={props.searchParameter}
        name='country'
        id='country'
        className='form-control'
        onChange={handleSelectFilter}
      >
        {searchBarOptions.map((item) => (
          <option key={`${item.code}${item.name}${item.label}`} value={item.name}>
            {`${item.label}`}
          </option>
        ))}
      </select>
      <button
        disabled={props.searchParameter === '' || props.searchTerm === ''}
        name='search-btn'
        className='btn btn-default'
        type='button'
        onClick={(e) => handleSearchSubmit(e)}
      >
        Search
      </button>
      <button
        disabled={props.searchParameter === '' || props.searchTerm === ''}
        name='reset-btn'
        className='btn btn-default'
        type='button'
        onClick={(e) => handleSearchReset(e)}
      >
        Reset
      </button>
    </div>
  )
}

const mapStateToProps = (state) => ({
  searchTerm: state.transactionSearch.searchTerm,
  searchParameter: state.transactionSearch.searchParameter,
  searchError: state.transactionSearch.error,
  filter: state.statusFilter.statusFilter,
  sortField: state.txGridSort.sortField,
  sortOrder: state.txGridSort.order,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchUsersTx,
      navigateToPage: (p) => ownProps.history.push('#/page/' + p),
      termValidationErrorShow,
      doTxSearch,
      resetTxSearch,
      resetCSVExport,
      disableCountryFilter,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchBar))
